import { GroupSectionPage } from '@/components/GroupSectionPage/GroupSectionPage';
import { RouteRestrictions } from '@/utilities';
import { restrictedRoute } from '@/utilities/restrictedRoute';

export default restrictedRoute(GroupSectionPage, {
  requiresEvery: [RouteRestrictions.COMMUNITY_ACCESS],
});
